import { useState } from 'react';
import { ApiMethod } from 'services/api';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';

const GET_STATS_FOR_TIME_RANGE = '/analytics/getStatsForTimeRange';

const generateJourneyConversionMetricsPayload = (
  journeyId: number,
  campaignIds: number[],
  startTime: string,
  endTime: string,
) => ({
  campaignIds,
  startTime,
  endTime,
  workflowId: journeyId,
  selectedMetrics: [
    {
      name: 'Conversions',
    },
  ],
});

export type GetJourneyConversionRequest = {
  journeyId: number;
  campaignIds: number[];
  startAt: string;
  endAt: string;
};
export type JourneyConversionDataResponse = {
  results: {
    Conversions: {
      value: Record<string, number>;
    };
  };
};

export type JourneyConversionPayload = {
  campaignIds: number[];
  startTime: string;
  endTime: string;
  workflowId: number;
  selectedMetrics: {
    name: string;
  }[];
};
export const useGetJourneyConversionsMetricsForCampaigns = () => {
  const [journeyConversionData, setJourneyConversionData] = useState<Record<string, number>>({});
  const [hasLoaded, setHasLoaded] = useState(false);

  const { mutate, error, isLoading } = useRestMutation<
    GetJourneyConversionRequest,
    JourneyConversionPayload
  >(GET_STATS_FOR_TIME_RANGE, ApiMethod.post, {
    onSuccess: (data: any) => {
      setJourneyConversionData(data.results.Conversions.value);
      setHasLoaded(true);
    },
    onError: () => {
      setHasLoaded(true);
    },
  });

  const getJourneyConversionsMetricsForCampaigns = (
    journeyId: number,
    campaignIds: number[],
    startAt: string,
    endAt: string,
  ) => {
    const payload = generateJourneyConversionMetricsPayload(journeyId, campaignIds, startAt, endAt);
    if (!startAt || !endAt) return;
    mutate(payload);
  };

  return {
    getJourneyConversionsMetricsForCampaigns,
    journeyConversionData,
    isLoading: isLoading || !hasLoaded,
    error,
  };
};
